
export default {
	rsaKey:'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQChU3W7TJzRcdcSt5BqD3mybuNETfwtqtCjqVQXXtI1lzjAg+Xd6TUvMYuhmHbUwP8itu1CvlPihqUzQEpnfodE48aEUZ5ybX2ZTUoiq94UcqIm4rV5hv7m8voiWes6N6iC3znGII6wgQSpV9GQA6bj16G1VeS4l1hQuoOyuqGWmwIDAQAB',
	AESPass:'Client-TicketPIC',
}